import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const styles = {
  table: ({ spacing }) => ({
    borderSpacing: `0 ${spacing(1)}`,
    borderCollapse: 'separate',
    tableLayout: 'fixed',
  }),
  tableCell: ({ palette, spacing }) => ({
    padding: spacing(4, 1),
    backgroundColor: palette.colors.lightPale,
    borderBlock: `2px solid ${palette.colors.darkPale}`,
    '&:first-of-type': {
      paddingLeft: 3,
      borderRadius: '10px 0 0 10px',
      borderLeft: `2px solid ${palette.colors.darkPale}`,
    },
    '&:last-of-type': {
      borderRadius: '0 10px 10px 0',
      borderRight: `2px solid ${palette.colors.darkPale}`,
      paddingRight: 3,
    },
  }),
  headerRow: ({ palette }) => ({
    backgroundColor: palette.primary.main,
    '& > th': {
      backgroundColor: palette.primary.main,
      borderColor: `${palette.primary.main} !important`,
    },
  }),
  tableRow: {
    '& > th': {
      borderRadius: 'unset !important',
      borderRight: 'none !important',
      borderLeft: 'none !important',
    },
  },
};

export const ColoredTable = ({ header, rows, customStyles = {} }) => {
  return (
    <Table sx={[styles.table, customStyles.table]}>
      <TableHead>
        <TableRow sx={[styles.headerRow, customStyles.headerRow]}>
          {header.map((headerCell) => (
            <TableCell
              key={headerCell.cellKey}
              align="left"
              {...headerCell.cellProps}
              sx={[styles.tableCell, headerCell.cellStyles]}
            >
              {headerCell.content}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map(({ id, cells }) => (
          <TableRow key={id} sx={[styles.tableRow, customStyles.tableRow]}>
            {cells.map((rowCell) => (
              <TableCell key={rowCell.cellKey} {...rowCell.cellProps} sx={[styles.tableCell, rowCell.cellStyles]}>
                {rowCell.content}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const cellPropTypes = PropTypes.shape({
  content: PropTypes.node,
  cellKey: PropTypes.string,
  cellProps: PropTypes.shape({}),
  cellStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
});

ColoredTable.propTypes = {
  header: PropTypes.arrayOf(cellPropTypes).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      cells: PropTypes.arrayOf(cellPropTypes),
    }),
  ).isRequired,
  customStyles: PropTypes.shape({
    table: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    headerRow: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    tableRow: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  }),
};
